import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { ProjectService } from 'src/services/project.service'
import { getMimeType } from 'src/utils/file-download.util'

const usePatientVariableDocument = (
  variableId: number | undefined,
  patientFormId: number | undefined,
  patientId: string | number,
  projectId: string | number,
  enabled = true,
) => {
  const { isLoading, isError, error, data, refetch } = useQuery({
    queryKey: ['patient-variable-document', variableId, patientFormId, patientId, projectId],
    queryFn: () => ProjectService.getPatientFormDocument(variableId, patientFormId, patientId, projectId),
    enabled: enabled && variableId !== undefined && patientFormId !== undefined,
  })

  const objectUrl = useMemo(() => {
    if (!data?.data) return undefined
    return URL.createObjectURL(data.data as Blob)
  }, [data?.data])

  // Derive mimeType from the response Content-Type header, which is more
  // reliable than blob.type (which is sometimes empty for blobs created from
  // response data).
  const mimeType = useMemo((): string => {
    return getMimeType(data?.headers?.['content-type'] as string | undefined)
  }, [data?.headers])

  return { isLoading, isError, error, objectUrl, mimeType, refetch }
}

export { usePatientVariableDocument }
